/*
Application Name: Practice Aid.
Application URI: https://practice-aid.com/
Description: PracticeAid is a group of professionals with collective expertise in medical and dental science, hospital administration and software development. These experts have come together to work on path-breaking solutions in Healthcare IT and deliver tangible value.
Version: 1.0.0
Author: Practice Aid.
Author URI: https://practice-aid.com/
 “M/s Totall Practice Aid Private Limited, CIN U72900MP2022PTC059139”
*/

import * as actionTypes from 'Front/actions/actionTypes'
const initState = {
  response: [],
  message: '',
  type: '',
}

export default (state = initState, action = {}) => {
  switch (action.type) {
    //-- fileUpload 
    case actionTypes.FILE_UPLOAD_REQUEST:
      return {
        ...state,
        type: 'request',
        response: [],
        message: '',
      }
    case actionTypes.FILE_UPLOAD_SUCCESS:
      return {
        ...state,
        type: "fileUpload",
        response: action.payload.data,
        message: 'Success',
      }
    case actionTypes.FILE_UPLOAD_ERROR:
      return {
        ...state,
        response: action.payload.response.data,
        message: 'Error',
      }

    //-- AddInvitation 
    case actionTypes.ADD_CLINIC_INVITATION_REQUEST:
      return {
        ...state,
        type: 'request',
        response: [],
        message: '',
      }
    case actionTypes.ADD_CLINIC_INVITATION_SUCCESS:
      return {
        ...state,
        type: "addInvitation",
        response: action.payload.data,
        message: 'Success',
      }
    case actionTypes.ADD_CLINIC_INVITATION_ERROR:
      return {
        ...state,
        response: action.payload.response.data,
        message: 'Error',
      }

    default:
      return state
  }
}